import { environment } from "src/environments/environment"

export const API_CONSTANTS = {
    COUNTRIES: 'https://gist.githubusercontent.com/anubhavshrimal/75f6183458db8c453306f93521e93d37/raw/f77e7598a8503f1f70528ae1cbf9f66755698a16/CountryCodes.json',

    FIREBASE_CODE: `https://www.googleapis.com/identitytoolkit/v3/relyingparty/setAccountInfo?key=${environment.firebaseConfig.apiKey}`,

    REGISTER: `${environment.userServiceApiUrl}`,
    USERINFO: (userId: string) => `${environment.userServiceApiUrl}/${userId}`,
    SET_PASSWORD: (code: string) => `${environment.userServiceApiUrl}/password/${code}`,
    VERIFY_TOKEN: `${environment.userServiceApiUrl}/verify-firebase-token`,
    VERIFYEMAIL: (userId: string) => `${environment.userServiceApiUrl}/${userId}/resend-email`,
    VERIFYEMAIL_BY_EMAIL: (email: string) => `${environment.userServiceApiUrl}/${email}/resend-email-byEmail`,
    FORGOTPASSWORD: (email: string) => `${environment.userServiceApiUrl}/${email}/forgot`,
    CUSTOM_TOKEN: `${environment.userServiceApiUrl}/firebase-custom-token`,
    PRODUCT_DETAIL: (companyId: number) => `${environment.subscriptionApiUrl}/company-subscription/${companyId}/latest`,
    LINK_EXPIRY: `${environment.userServiceApiUrl}/link-expiry-check`,
    SERVICE_STATUS: `${environment.datonApiUrl}/services/status`,
    VALIDATA_SUBSCRIPTION: `${environment.subscriptionApiUrl}/company-subscription/validate-subscription`,
    USER_FROM_EMAIL: `${environment.userServiceApiUrl}/userByEmail`,
    IS_EMAIL_VERIFIED: `${environment.userServiceApiUrl}/email-verification-check`
}

export const API_ERRORS = {
    defaultError: { code: 'US000', message: 'Something went wrong, retry after some time.' },
    FIREBASE_CODES: {
        USER_NOT_FOUND: 'auth/user-not-found',
        EMAIL_ALREADY_EXISTS: 'auth/email-already-exists',
        INVALID_CREDENTIAL: 'auth/invalid-credential',
        INVALID_EMAIL: 'auth/invalid-email',
        INVALID_PASSWORD: 'auth/invalid-password',
        INVALID_ACTION_CODE: 'auth/invalid-action-code',
        WRONG_PASSWORD: 'auth/wrong-password',
        TOO_MANY_REQUESTS: 'auth/too-many-requests',
        REQUIRES_RECENT_LOGIN: 'auth/requires-recent-login',
        MFA_ALREADY_ENROLLED: 'auth/mfa-enrollment-already-complete',
        MFA_COUNT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
        MFA_ARGUMENT_ERROR: 'auth/argument-error',
        MFA_INVALID_CODE: 'auth/invalid-verification-code',
        MFA_TOTP_TIMEOUT: 'auth/totp-challenge-timeout',
        MFA_QUOTA_EXCEEDED: 'auth/quota-exceeded',
        MFA_TOKEN_EXPIRED: 'auth/user-token-expired',
        DEFAULT: 'DEFAULT'
    },
    FIREBASE_MESSAGES: {
        'auth/user-not-found': 'Incorrect email or password',
        'auth/email-already-exists': 'Incorrect email or password',
        'auth/invalid-credential': 'Incorrect email or password',
        'auth/invalid-email': 'Incorrect email or password',
        'auth/invalid-password': 'Incorrect email or password',
        'auth/wrong-password': 'Incorrect email or password',
        'auth/too-many-requests': 'Too many requests, try again after some time',
        'MFA_INVALID_CODE': 'Incorrect code. Please enter the correct one',
        'MFA_COUNT_EXCEEDED': 'Your account is already configured with MFA',
        'MFA_TOTP_TIMEOUT': 'Verification timeout, please refresh and login again',
        'auth/invalid-verification-code': 'Verification timeout, please refresh and login again',
        'MFA_QUOTA_EXCEEDED': 'Requests limit exceeded, please try after sometime',
        'auth/totp-challenge-timeout': 'Requests limit exceeded, please try after sometime',
        'MFA_TOKEN_EXPIRED': 'Your session is expired, please refresh to setup MFA',
        'auth/user-token-expired': 'Your session is expired, please refresh to setup MFA',
        'DEFAULT': 'Something went wrong please try again'
    }
}

export const PUBLIC_LINKS = {
    DATON: `https://www.sarasanalytics.com/saras-daton`,
    INSIGHTS: `https://www.sarasanalytics.com/saras-pulse`,
    PULSE: `https://www.sarasanalytics.com/saras-pulse`,
    SARAS: `https://www.sarasanalytics.com/`,
    IQ: '',
    BOOK_DEMO: 'https://go.sarasanalytics.com/meetings/schedule-consultation/lets-talk-data?utm_source=productlistingpage&utm_medium=app&utm_campaign=book-a-demo'
}